export default "__VITE_ASSET__Ccxqy7hV__"